import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const { signInGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const user = await signInGoogle(sessionId);
        toast.success(`Benvenuto ${user.name || user.email}`);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Accesso Google non riuscito");
        navigate("/login", { replace: true });
      }
    })();
  }, [signInGoogle, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-slate-950 flex items-center justify-center">
      <Loader2 className="h-8 w-8 text-accent animate-spin" />
    </div>
  );
}
